//export const API_BASE_URL='http://localhost:4000'
//export const API_BASE_URL='https://rentalhome.onrender.com'
export const API_BASE_URL='https://dharni-properties.onrender.com'
export  const MAP_API='AIzaSyDpxvdJfUO-5zaZGLXUsxAhnYhMkpfyT64'